import React from 'react';
import { IMG_IC_24_CHEVRON_DOWN } from 'images';
import style from './style.module.css';

const More = () => {
  return (
    <button className={style.root}>
      <p>Ещё</p>
      <img src={IMG_IC_24_CHEVRON_DOWN} alt='' />
    </button>
  );
};

export default More;
